import { GlobalStyle } from "../../constants/global-style";
import ProvideLoggedInUser from "../../providers/ProvideLoggedInUser";
import ProvideLandingSearch from "../../providers/ProvideLandingSearch";
import UsersAffiliatorsApp from "../../users/affiliators/App";

export default function Affiliators() {
  return (
    <>
      <GlobalStyle />
      <ProvideLoggedInUser>
        <ProvideLandingSearch>
          <UsersAffiliatorsApp />
        </ProvideLandingSearch>
      </ProvideLoggedInUser>
    </>
  );
}
